export const testEnvVariables = () => {
    console.log('Environment Variables Test:');
    console.log('NODE_ENV:', process.env.NODE_ENV);
    console.log('Supabase URL:', process.env.REACT_APP_SUPABASE_URL);
    console.log('Supabase Key:', process.env.REACT_APP_SUPABASE_ANON_KEY);
};